import React, { useCallback } from 'react'
import { Grid } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { useTranslation } from 'react-i18next'
import DropzoneFilesInput from 'components/common/inputs/DropzoneFilesInput'
import DazzedParagraph14 from 'components/common/text/DazzedParagraph14'
import FileLarge from 'components/common/icons/bulk-invite/file-large'
import FileSmall from 'components/common/icons/bulk-invite/file-small'
import { trackEvent } from 'utils/analyticsUtils'

const useStyles = makeStyles({
  selectedFile: {
    background: 'var(--bg-color-14)',
    height: '153px',
    borderRadius: 10
  },
  dropzone: {
    border: '1px dashed var(--border-color-28)',
    borderRadius: 10,
    height: '153px'
  },
  link: {
    color: 'var(--text-color-3)',
    textDecoration: 'underline'
  }
})

const CSV_ACCEPTED_FORMATS = [
  '.csv',
  'text/csv',
  'application/csv',
  'text/plain',
  'text/x-csv',
  'text/comma-separated-values',
  'text/x-comma-separated-values',
  'application/vnd.ms-excel'
]

const BulkCreatePatientsFileInput = ({ onFileUpload = () => {}, selectedFileName, disabled = false }) => {
  const classes = useStyles()
  const { t } = useTranslation()

  const handleFileSelected = useCallback(
    files => {
      if (disabled) {
        return
      }

      trackEvent('bulk create patients - file selected')
      const file = files[0]
      if (!file) {
        return
      }

      const blob = new Blob([file.data], { type: 'text/csv' })
      const fileObject = new File([blob], file.key, { type: 'text/csv' })
      onFileUpload({ file: fileObject, fileName: file.key })
    },
    [disabled, onFileUpload]
  )

  return selectedFileName ? (
    <Grid container className={classes.selectedFile} alignItems="center" justifyContent="center" spacing={1}>
      <Grid item>
        <FileSmall />
      </Grid>
      <Grid item>
        <DazzedParagraph14 bold>{selectedFileName}</DazzedParagraph14>
      </Grid>
    </Grid>
  ) : (
    <DropzoneFilesInput
      files={[]}
      onChange={handleFileSelected}
      className={classes.dropzone}
      acceptedFormats={CSV_ACCEPTED_FORMATS}
      filenameGenerator={(extension, fileName) => fileName}
      multipleFiles={false}
      maxFilesNumber={1}
      disabled={disabled}
      emptyStateComponent={
        <Grid container alignItems="center" justifyContent="center" direction="column" spacing={1}>
          <Grid item>
            <FileLarge />
          </Grid>
          <Grid item xs={7}>
            <DazzedParagraph14 strong textAlign="center">
              {t('pages.accountSettings.advancedActions.bulkCreatePatients.dialog.dropzoneText_1')}
              <span className={classes.link}>
                {t('pages.accountSettings.advancedActions.bulkCreatePatients.dialog.dropzoneText_2')}
              </span>
            </DazzedParagraph14>
          </Grid>
        </Grid>
      }
    />
  )
}

export default BulkCreatePatientsFileInput
